import { CustomFieldBaseModel, DataType } from "./custom-field-base-model";

export class CustomFieldModel extends CustomFieldBaseModel {
    caption?: string;
    groupName?: string;
    groupSubName?: string;
    order?: number;

    constructor(name: string, order: number, dataType: DataType, value: any, caption?: string, groupName?: string, groupSubName?: string, keyValuePairs?: any) {
        super();
        this.name = name;
        this.order = order;
        this.dataType = dataType;
        this.value = value;
        this.caption = caption;
        this.groupName = groupName;
        this.groupSubName = groupSubName;
        if (keyValuePairs != undefined) {
            this.keyValues = keyValuePairs;
        }
    }

}